module.exports = __webpack_public_path__ + "img/5.6ef2ee96.png";